<template>
  <div>
    <q-card
      :class="[
        datosEnabled !== -1
          ? 'container_box shadow-1 cursor-pointer'
          : 'container_box_disabled',
        showTitle ? '' : 'margen',
      ]"
      @click="openURL"
      :style="widthCard ? `width: ${widthCard}` : ''"
    >
      <q-img
        v-if="datos.file"
        :src="imagen ? imagen.url : require(`@/assets/${imgDefault}`)"
        :alt="datos.name"
        :class="[datosEnabled == -1 ? 'disabled' : '', 'Imagen']"
        :ratio="1"
        contain
      >
        <div
          v-if="datos.name && showTitle"
          class="Titulo absolute-top text-subtitle text-center"
        >
          {{ datos.name }}
        </div>
      </q-img>
    </q-card>
  </div>
</template>

<script>
import { QCard, QImg } from 'quasar';
import Resources from '@/components/shared/mixins/Resources.js';

export default {
  props: {
    datos: Object,
    datosEnabled: Number,
    widthCard: {
      required: false,
      type: String,
      default: () => null
    },
    showTitle: Boolean,
    imgDefault: {
      type: String,
      default: function () {
        return 'img/icon-image-square.png';
      }
    }
  },
  data () {
    return {
      imagen: null
    };
  },
  mixins: [Resources],
  created () {
    this.imagen = this.searchResource(this.datos.file, 'imagen');
  },
  computed: {},
  methods: {
    openURL () {
      if (this.datosEnabled === -1) return;
      this.$emit('openURL', this.datos);
    }
  },
  components: {
    QCard,
    QImg
  }
};
</script>

<style lang="scss" scoped>
.container_box {
  transition: box-shadow 0.3s;
  padding: 0;
  background-color: #ffffff;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 2px 1px -1px rgba(0, 0, 0, 0.12),
    0 1px 1px 0 rgba(0, 0, 0, 0.14);
  &:hover {
    box-shadow: $shadow-8;
  }
  margin: auto;
}

.container_box_disabled {
  padding: 0;
  margin: auto;
}

.disabled {
  filter: grayscale(70%);
  opacity: 0.3;
}

.Imagen {
  border-radius: 12px;
}
.Titulo {
  background: white;
  color: #000;
  padding: 8px;
  font-weight: bold;
  font-size: 12px;
}

.text-subtitle {
  font-family: DINPro;
  font-size: 12px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: -0.6px;
  color: #000;
}

.margen {
  padding: 10px;
}
</style>
